module.exports = "<div>\r\n  <span>{{'access-denied.usuario-sin-permisos' | translate}}</span>\r\n</div>\r\n"